import { useCallback, useState } from 'react';
import { ResultsGrid } from '../ResultsGrid';
import type { PinnedResultEntry } from '../../../core/types/workspaceTypes';

type Props = {
  pinned: PinnedResultEntry;
  tabId: string;
  zoomLevel: number;
  connectionId?: string;
  database?: string;
  engineId?: string;
};

/**
 * Renders a pinned execution snapshot. Owns its own active-result-set index so
 * the inner Output / Result N tabs work the same as for the live execution,
 * with capabilities and cache URIs picked from the snapshot's per-index arrays.
 */
export function PinnedResultsTabContent({
  pinned,
  tabId,
  zoomLevel,
  connectionId,
  database,
  engineId,
}: Props) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleActiveResultSetChange = useCallback((index: number) => {
    setActiveIndex(index);
  }, []);

  const safeIndex = Math.min(activeIndex, Math.max(0, pinned.resultSets.length - 1));
  const activeCacheUri = pinned.sourceUris?.[safeIndex];
  const activeRowCount = pinned.sourceRowCounts?.[safeIndex];
  const activeCapabilities = pinned.capabilitiesByIndex?.[safeIndex];

  return (
    <ResultsGrid
      tabId={`${tabId}-pinned-${pinned.id}`}
      resultSets={pinned.resultSets}
      messages={pinned.messages}
      zoomLevel={zoomLevel}
      connectionId={connectionId}
      database={database}
      engineId={engineId}
      cacheUri={activeCacheUri}
      resultSetCacheUris={pinned.sourceUris}
      remoteTotalRowCount={activeRowCount}
      capabilities={activeCapabilities}
      onActiveResultSetChange={handleActiveResultSetChange}
    />
  );
}
